import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { JobPublishOrUnpublish } from "./JobPublishAPI";


const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const JobPublishOrUnpublishAsync = createAsyncThunk(
  "JobPublishOrUnpublish/add",
  async ({uuid, keyword}) => {
    try {
      const data = await JobPublishOrUnpublish(uuid, keyword);
      // console.log("data in slice", data);
      return data;
    } catch (error) {
      // console.log("error :", error);
      return error;
      // return rejectWithValue(error.message);
    }
  }
);


const JobPublishOrUnpublishSlice = createSlice({
  name: "JobPublishOrUnpublish",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder

      
      .addCase(JobPublishOrUnpublishAsync.fulfilled, (state, action) => {
        state.loading = false;
        if (Array.isArray(state.data)) {
          state.data?.push(action.payload);
        } else {
          state.data = [action.payload]; // Initialize as an array if it's not already
        }
      })
      .addCase(JobPublishOrUnpublishAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to add CompanyReview";
      })
      
  },
});

export const selectPublishedJob = (state) => state.jobPublishOrUnpublish.data;

export default JobPublishOrUnpublishSlice.reducer;
